<script setup lang="ts">
import { ref, watch } from 'vue'
import { mediaApi } from '@ck/api-client'

// Miniatura da capa do veículo para a fila: baixa o blob autenticado do coverMediaId (fonte
// única) e cai no gradiente quando a OS não tem capa.
const props = defineProps<{ mediaId: string | null }>()
const url = ref<string | null>(null)
watch(() => props.mediaId, async (id, _previous, onCleanup) => {
  url.value = null
  if (!id) return
  let created: string | null = null
  try { created = URL.createObjectURL(await mediaApi.fetchFile(id)) } catch { created = null }
  url.value = created
  onCleanup(() => { if (created) URL.revokeObjectURL(created) })
}, { immediate: true })
</script>

<template>
  <span class="thumb" aria-hidden="true"><img v-if="url" :src="url" alt=""></span>
</template>

<style scoped>
.thumb { display: block; width: 40px; height: 30px; flex-shrink: 0; border-radius: 7px; overflow: hidden; background: linear-gradient(135deg, var(--ck-maroon-700), var(--ck-ink-900)); }
.thumb img { width: 100%; height: 100%; object-fit: cover; }
</style>
